import { gql } from '@apollo/client';

export const PUBLIC_API_KEY_ITEM_FRAGMENT = gql`
  fragment PublicApiKeyItemFields on PublicApiKeyItem {
    id
    apiKeyId
    partnerId
    name
    description
    allowedOperations {
      resource
      operations
    }
    usagePlanId
    createdAt
    createdBy
    disabled
    disabledAt
    disabledReason
    rotatedToApiKeyId
    maskedApiKey
    apiKey
  }
`;
